import { render, staticRenderFns } from "./BRELAG_MAGContact.vue?vue&type=template&id=6e5f8485&"
import script from "./BRELAG_MAGContact.vue?vue&type=script&lang=js&"
export * from "./BRELAG_MAGContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports